const FONT_LINK_ID = 'glanceai-auth-ui-inter';

/**
 * Injects Google Fonts (Inter) once. Safe for SSR / Node (no-op without document).
 * Called when `@glanceai/common/ui` is loaded so every host app gets the same webfont.
 */
export function ensureAuthUiFonts(): void {
  if (typeof document === 'undefined') {
    return;
  }
  if (document.getElementById(FONT_LINK_ID)) {
    return;
  }
  if (document.querySelector('link[href*="fonts.googleapis.com/css2"][href*="family=Inter"]')) {
    return;
  }

  const preGoogle = document.createElement('link');
  preGoogle.rel = 'preconnect';
  preGoogle.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preGoogle);

  const preGstatic = document.createElement('link');
  preGstatic.rel = 'preconnect';
  preGstatic.href = 'https://fonts.gstatic.com';
  preGstatic.crossOrigin = 'anonymous';
  document.head.appendChild(preGstatic);

  const link = document.createElement('link');
  link.id = FONT_LINK_ID;
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
  document.head.appendChild(link);
}
